export default (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.77284 14.2883C3.40905 15.6521 3.40905 17.8633 4.77284 19.227L4.7735 19.2277C6.13728 20.5915 8.34842 20.5915 9.7122 19.2277L19.2276 9.71226C20.5914 8.34848 20.5914 6.13735 19.2276 4.77356L19.227 4.7729C17.8632 3.40912 15.6521 3.40912 14.2883 4.7729L4.77284 14.2883ZM3.71218 20.2877C1.76261 18.3381 1.76261 15.1773 3.71218 13.2277L13.2276 3.71224C15.1772 1.76267 18.3381 1.76267 20.2876 3.71224L20.2883 3.7129C22.2379 5.66247 22.2379 8.82335 20.2883 10.7729L10.7729 20.2884C8.82329 22.2379 5.66241 22.2379 3.71284 20.2884L3.71218 20.2877Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.46964 8.46964C8.76254 8.17675 9.23741 8.17675 9.5303 8.46964L15.5303 14.4696C15.8232 14.7625 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7625 15.8232 14.4696 15.5303L8.46964 9.5303C8.17675 9.23741 8.17675 8.76254 8.46964 8.46964Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7803 7.71964C18.0732 8.01254 18.0732 8.48741 17.7803 8.7803L15.5303 11.0303C15.2374 11.3232 14.7625 11.3232 14.4696 11.0303C14.1768 10.7374 14.1768 10.2625 14.4696 9.96964L16.7196 7.71964C17.0125 7.42675 17.4874 7.42675 17.7803 7.71964Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.44345 18.313C3.44345 17.8988 3.77924 17.563 4.19345 17.563L11.2123 17.563C11.6265 17.563 11.9623 17.8988 11.9623 18.313C11.9623 18.7272 11.6265 19.063 11.2123 19.063L4.19345 19.063C3.77924 19.063 3.44345 18.7272 3.44345 18.313Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.99997 15.313C2.99997 14.8988 3.33576 14.563 3.74997 14.563L14.25 14.563C14.6642 14.563 15 14.8988 15 15.313C15 15.7272 14.6642 16.063 14.25 16.063L3.74997 16.063C3.33576 16.063 2.99997 15.7272 2.99997 15.313Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.22507 12.313C5.22507 11.8988 5.56086 11.563 5.97507 11.563H12C12.4142 11.563 12.75 11.8988 12.75 12.313C12.75 12.7273 12.4142 13.063 12 13.063H5.97507C5.56086 13.063 5.22507 12.7273 5.22507 12.313Z"
      fill="currentColor"
    />
  </>
);
